<template>
    <CreateServiceReport1></CreateServiceReport1>
</template>
<script>
    import CreateServiceReport1 from '@/components/CreateServiceReport1.vue'
    export default {
        name: 'employee-sign',
        components: {
            CreateServiceReport1
        }
    }
</script>